
import { useStore } from '@/store'
import { defineComponent, ref } from 'vue'
import { computed } from 'vue'
import frontSettings from '@/settings/front-settings.json'
import FormOption from '@/components/Form/FormOption.vue'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import Analytics from '@/singletons/analytics'
import FormScrollableTab from '@/components/Abstract/FormScrollableTab.vue'

export default defineComponent({
  name: 'FormFront',
  components: {
    FormScrollableTab,
    FormOption
  },
  props: {
    index: Number
  },
  setup() {
    const store = useStore()
    const configName = ref('configFrontId')
    const config = computed(() => store.getters[configName.value])
    const options = computed(() => frontSettings.futaShapeTextures)

    const onClick = (option: any) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_FRONT, option.id)
      Analytics.instance.sendFrontEvent(option.id)
    }

    return {
      config,
      configName,
      frontSettings,
      onClick,
      options
    }
  }
})
